!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = r() : "function" == typeof define && define.amd ? define(r) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.sv = r());
}(this, function () {
  "use strict";

  return [{
    locale: "sv",
    pluralRuleFunction: function pluralRuleFunction(e, r) {
      var t = String(e).split("."),
          a = !t[1],
          n = Number(t[0]) == e,
          o = n && t[0].slice(-1),
          m = n && t[0].slice(-2);
      return r ? 1 != o && 2 != o || 11 == m || 12 == m ? "other" : "one" : 1 == e && a ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "år",
        relative: {
          0: "i år",
          1: "nästa år",
          "-1": "i fjol"
        },
        relativeTime: {
          future: {
            one: "om {0} år",
            other: "om {0} år"
          },
          past: {
            one: "för {0} år sedan",
            other: "för {0} år sedan"
          }
        }
      },
      "year-short": {
        displayName: "år",
        relative: {
          0: "i år",
          1: "nästa år",
          "-1": "i fjol"
        },
        relativeTime: {
          future: {
            one: "om {0} år",
            other: "om {0} år"
          },
          past: {
            one: "för {0} år sen",
            other: "för {0} år sen"
          }
        }
      },
      month: {
        displayName: "månad",
        relative: {
          0: "denna månad",
          1: "nästa månad",
          "-1": "förra månaden"
        },
        relativeTime: {
          future: {
            one: "om {0} månad",
            other: "om {0} månader"
          },
          past: {
            one: "för {0} månad sedan",
            other: "för {0} månader sedan"
          }
        }
      },
      "month-short": {
        displayName: "m",
        relative: {
          0: "denna mån.",
          1: "nästa mån.",
          "-1": "förra mån."
        },
        relativeTime: {
          future: {
            one: "om {0} mån.",
            other: "om {0} mån."
          },
          past: {
            one: "för {0} mån. sen",
            other: "för {0} mån. sen"
          }
        }
      },
      day: {
        displayName: "dag",
        relative: {
          0: "i dag",
          1: "i morgon",
          2: "i övermorgon",
          "-2": "i förrgår",
          "-1": "i går"
        },
        relativeTime: {
          future: {
            one: "om {0} dag",
            other: "om {0} dagar"
          },
          past: {
            one: "för {0} dag sedan",
            other: "för {0} dagar sedan"
          }
        }
      },
      "day-short": {
        displayName: "dag",
        relative: {
          0: "i dag",
          1: "i morgon",
          2: "i övermorgon",
          "-2": "i förrgår",
          "-1": "i går"
        },
        relativeTime: {
          future: {
            one: "om {0} d",
            other: "om {0} d"
          },
          past: {
            one: "för {0} d sedan",
            other: "för {0} d sedan"
          }
        }
      },
      hour: {
        displayName: "timme",
        relative: {
          0: "denna timme"
        },
        relativeTime: {
          future: {
            one: "om {0} timme",
            other: "om {0} timmar"
          },
          past: {
            one: "för {0} timme sedan",
            other: "för {0} timmar sedan"
          }
        }
      },
      "hour-short": {
        displayName: "tim",
        relative: {
          0: "denna timme"
        },
        relativeTime: {
          future: {
            one: "om {0} tim",
            other: "om {0} tim"
          },
          past: {
            one: "för {0} tim sedan",
            other: "för {0} tim sedan"
          }
        }
      },
      minute: {
        displayName: "minut",
        relative: {
          0: "denna minut"
        },
        relativeTime: {
          future: {
            one: "om {0} minut",
            other: "om {0} minuter"
          },
          past: {
            one: "för {0} minut sedan",
            other: "för {0} minuter sedan"
          }
        }
      },
      "minute-short": {
        displayName: "min",
        relative: {
          0: "denna minut"
        },
        relativeTime: {
          future: {
            one: "om {0} min",
            other: "om {0} min"
          },
          past: {
            one: "för {0} min sen",
            other: "för {0} min sen"
          }
        }
      },
      second: {
        displayName: "sekund",
        relative: {
          0: "nu"
        },
        relativeTime: {
          future: {
            one: "om {0} sekund",
            other: "om {0} sekunder"
          },
          past: {
            one: "för {0} sekund sedan",
            other: "för {0} sekunder sedan"
          }
        }
      },
      "second-short": {
        displayName: "sek",
        relative: {
          0: "nu"
        },
        relativeTime: {
          future: {
            one: "om {0} sek",
            other: "om {0} sek"
          },
          past: {
            one: "för {0} s sen",
            other: "för {0} s sen"
          }
        }
      }
    }
  }, {
    locale: "sv-AX",
    parentLocale: "sv"
  }, {
    locale: "sv-FI",
    parentLocale: "sv"
  }];
});